export default __webpack_public_path__ + "static/media/sports_logos.ed434ef3.csv";